// Imperative bounce for the cart affordances (top-bar circle, tablet FAB, mobile bar).
//
// The reactive store patches cart counts with fine-grained text updates, so a
// lifecycle `onupdate` on the surrounding element does not reliably fire on a
// cart change. Instead every mounted affordance registers its DOM node here and
// `$m.cart.update_cart` pings `trigger_cart_bounce()` on each add/remove, so all
// visible surfaces bounce in sync regardless of how the store rerenders.

const BOUNCE_KEYFRAMES = [{transform: 'scale(1)'}, {transform: 'scale(1.2)'}, {transform: 'scale(1)'}]

const targets = new Set<Element>()

/** Replay the bounce on every currently-mounted cart affordance. */
export function trigger_cart_bounce() {
    for (const dom of targets) {
        dom.animate(BOUNCE_KEYFRAMES, {duration: 300, easing: 'linear'})
    }
}

/**
 * Lifecycle hooks that register the host element as a bounce target. Spread onto
 * any cart affordance — `<button {...cart_bounce}>` — that should react to
 * add/remove. Uses the Web Animations API, so it adds no wrapper element and
 * never touches the host's layout, styles or class list.
 */
export const cart_bounce = {
    oncreate({dom}: {dom: Element}) {
        targets.add(dom)
    },
    onremove({dom}: {dom: Element}) {
        targets.delete(dom)
    },
}
